
export default function iconServiceFactory() {
  // Load SVGs as HTML markup
  // const requireIcon = require.context('!html-loader!@/assets/icons', true, /\.svg$/);

  let thisService = {
    // getMarkup,
    getMarkupFromPath,
  };

  return thisService;

  ////////////////////

  // function getMarkup(iconName) {
  //   try {
  //     return requireIcon(`./${iconName}`);
  //   } catch(e) {
  //     // Don't throw an error just for a missing icon
  //     return undefined;
  //   }
  // }

  function getMarkupFromPath(path) {
    return fetch(path, {cache: 'default'}).then(r => {
      if (!r.ok) {
        return;
      }

      return r.text();
    });
  }
}
